import { Input } from '@hue/design-system';
import { useEffect, useRef, useState } from 'react';

/** Leitores USB/Bluetooth que emulam teclado; a leitura nunca envia o formulário. */
export function BarcodeReaderField({
  onRead,
  disabled = false,
  scopeKey = '',
}: {
  onRead: (code: string) => Promise<void>;
  disabled?: boolean;
  scopeKey?: string;
}) {
  const [text, setText] = useState('');
  const queue = useRef(Promise.resolve());
  const scope = useRef(scopeKey);
  useEffect(() => {
    scope.current = scopeKey;
  }, [scopeKey]);
  return (
    <Input
      label="Ler código de barras"
      placeholder="Clique aqui e use o leitor"
      value={text}
      disabled={disabled}
      autoComplete="off"
      hint="O leitor deve digitar o código e Enter. A leitura seleciona a apresentação; confira os dados antes de registrar."
      onChange={(event) => setText(event.target.value)}
      onKeyDown={(event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        const code = event.currentTarget.value.trim();
        if (!code) return;
        setText('');
        queue.current = queue.current
          .then(() => (scope.current === scopeKey ? onRead(code) : undefined))
          .catch(() => undefined);
      }}
    />
  );
}
